import * as React from 'react';
import CreateSvgIcon from '../components/CreateSvgIcon';
import { registerIcons } from '@uifabric/styling/lib/utilities/icons';

const RewardsRegular = CreateSvgIcon({
    Svg: props => (
        <svg
            width="24"
            height="24"
            viewBox="0 0 22 22"
            {...props}
            xmlns="http://www.w3.org/2000/svg">
            <path d="M20.25 1.99951C21.2165 1.99951 22 2.78301 22 3.74951V6.79222C22 7.81638 21.4309 8.75569 20.5231 9.2298L14.2413 12.5101C15.8773 13.3319 17 15.0253 17 16.9809C17 19.7423 14.7614 21.9809 12 21.9809C9.23858 21.9809 7 19.7423 7 16.9809C7 15.0253 8.12271 13.3319 9.75875 12.5101L3.47693 9.2298C2.56913 8.75569 2 7.81638 2 6.79222V3.74951C2 2.78301 2.7835 1.99951 3.75 1.99951H20.25ZM12 13.4809C10.067 13.4809 8.5 15.0479 8.5 16.9809C8.5 18.9139 10.067 20.4809 12 20.4809C13.933 20.4809 15.5 18.9139 15.5 16.9809C15.5 15.0479 13.933 13.4809 12 13.4809ZM15.5 3.49851H8.5V10.1605L11.8843 11.9284C11.9568 11.9663 12.0432 11.9663 12.1157 11.9284L15.5 10.1595V3.49851ZM7 3.49851L3.75 3.49951C3.61193 3.49951 3.5 3.61144 3.5 3.74951V6.79222C3.5 7.25775 3.75869 7.68471 4.17133 7.90021L7 9.37651V3.49851ZM20.25 3.49951L17 3.49851V9.37651L19.8287 7.90021C20.2413 7.68471 20.5 7.25775 20.5 6.79222V3.74951C20.5 3.61144 20.3881 3.49951 20.25 3.49951Z" />
        </svg>
    ),
    displayName: 'RewardsRegular',
});

export default 'RewardsRegular';

registerIcons({
    icons: {
        RewardsRegular: <RewardsRegular />,
    },
});
